/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Button,
  Paper,
  CircularProgress,
  TextField,
  SxProps,
  Theme
} from "@mui/material";
import { useJobs } from "./useJobs";
import Grid from "@mui/material/Grid";
import { LogsViewer } from "./logsView";
import { useEffect } from "react";

export const PageJob = ({idJob, sxList}: { idJob?:  any; sxList?:  SxProps<Theme>}) => {
  const {
    job,
    get
  } = useJobs({
    includes: [],
    disabledGetAll: true,
    disabledShowId: false,
  });

  useEffect(() => {
    if (idJob) get({id: idJob})
  }, [idJob])

  return (
    <Paper
      sx={{
        width: "100%",
        height: "calc(100vh - calc(var(--drawer-mini-width) + 80px) )",
        padding: "0px 8px",
        overflow: "auto",
      }}
      elevation={0}
    >
      <Grid container spacing={1} sx={{ height: "100%" }}>
        <Grid size={3}>
          <Box
            sx={{
              overflow: "auto",
              height: "100%",
              padding: "5px 0px",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Grid container spacing={1}>
              <Grid size={12}>
                <TextField
                  margin="normal"
                  required
                  disabled
                  value={job?.id}
                  fullWidth
                  id="name"
                  label="Id"
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  margin="normal"
                  required
                  disabled
                  value={job?.type}
                  fullWidth
                  id="type"
                  label="Tipo"
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid size={12}>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid size={9} sx={{ p: "0px", borderLeft: "1px solid #e3e3e3", ...sxList }}>
          <LogsViewer logs={job.logs} />
        </Grid>
      </Grid>
    </Paper>
  );
};
